import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'rcp-button-minimal',
  template: `
    <button class="rcp-button-minimal">
      <span class="button-label">
        <ng-content></ng-content>
      </span>
      @if (icon()) {
        <span class="button-icon">
          <fa-icon [icon]="icon()"></fa-icon>
        </span>
      }
    </button>
  `,
  styles: `
    .rcp-button-minimal {
      /* normalizations */
      border: none;

      /* main */
      color: var(--col-text-secondary);
      font-size: var(--font-size-small);
      font-weight: var(--font-weight-semi-bold);

      display: inline-flex;
      gap: var(--spacing-sm);

      cursor: pointer;

      &:hover {
        color: var(--col-active);
        text-decoration: underline;
      }
    }
  `,
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ButtonMinimalComponent {
  icon = input<IconProp>();
}
